import segment from 'common/segment';
import { apiCall } from './api-call';

const OPTIN_TRACK_EVENT = 'Newsletter Optin Clicked';

const subscribeButton = document.getElementById('js-newsletter-subscribe-btn');
const successMessage = document.getElementsByClassName(
  'js-newsletter-success'
)[0];
const errorMessage = document.getElementsByClassName('js-newsletter-error')[0];

subscribeButton &&
  subscribeButton.addEventListener('click', event => {
    event.preventDefault();
    const payload = JSON.stringify({ user: { juul_newsletter: '1' } });
    segment.track(OPTIN_TRACK_EVENT);

    apiCall('/api/v1/profile', 'PUT', payload)
      .done(() => {
        subscribeButton.classList.add('hide');
        successMessage.classList.remove('hide');
      })
      .fail(() => {
        errorMessage.classList.remove('hide');
      });
  });
